'use client';

import { createContext, useContext } from 'react';

/**
 * The company phone number, from the Storyblok settings story, for the client
 * components that offer a visitor a person to call.
 *
 * It is one number in one place: the USP bar and the results promotion band
 * each showed one from its own source, and they disagreed. Changing it is a
 * CMS edit, never a code change.
 */

const SiteContactContext = createContext<{ phoneNumber: string | null }>({ phoneNumber: null });

export const SiteContactProvider: React.FC<{
    phoneNumber: string | null;
    children: React.ReactNode;
}> = props => (
    <SiteContactContext.Provider value={{ phoneNumber: props.phoneNumber }}>
        {props.children}
    </SiteContactContext.Provider>
);

export function useSitePhoneNumber(): string | null {
    return useContext(SiteContactContext).phoneNumber;
}
